import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type DeleteAttendEventPath =
  operations['AdminGroupEventController_deleteGroupEvent']['parameters']['path'];
type DeleteAttendEventHeaders =
  operations['AdminGroupEventController_deleteGroupEvent']['parameters']['header'];

interface DeleteAttendEventProps {
  path: DeleteAttendEventPath;
  headers?: OmitGroupIdInHeader<DeleteAttendEventHeaders>;
}

type DeleteAttendEventResponse = number;

export async function deleteAttendEvent({
  path,
  headers,
}: DeleteAttendEventProps): Promise<DeleteAttendEventResponse | false> {
  const response = await authenticateRequest<DeleteAttendEventResponse>({
    method: 'delete',
    url: `/api/v1/admin/group-event/${path.groupEventId}`,
    headers,
  });

  console.log('deleteAttendEvent', { response });
  return response;
}
